import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Fragment from 'vue-fragment';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import './plugins';
import App from './app/app.vue';
import './main.scss';
import router from './route-guard';
import store from './app/app-state';
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import fr from './locales/fr.json';
import money from 'v-money';
import './plugins/filter.js';
import '@fortawesome/fontawesome-pro/css/all.css'
import '@fortawesome/fontawesome-pro/js/all.js'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Fragment.Plugin);
Vue.use(VueI18n);
Vue.config.productionTip = false;
Vue.use(money, { precision: 4 });


const messages = {
  en: { message: en },
  fr: { message: fr }
};

const i18n = new VueI18n({
  locale: "en",
  messages
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
